import { Controller, type FieldPath, type FieldValues, useFormContext } from 'react-hook-form';
import { Textarea, type TextareaProps } from '../../../Form/TextArea';
import type { HookInputBaseProps } from '../../types';

export interface HookTextareaProps<T extends FieldValues = FieldValues> extends HookInputBaseProps<T>, TextareaProps {
  name: FieldPath<T>;
  label: string;
}

export const HookTextarea = <T extends FieldValues>(props: HookTextareaProps<T>) => {
  const { name, required, validate, id, formMethods, ...rest } = props;
  const { control } = useFormContext<T>(); // TODO: Remove it when all parent components pass formMethods
  const idOrName = id || name;

  return (
    <Controller
      name={name}
      rules={{ required: required && 'Required', validate }}
      control={formMethods?.control || control}
      render={({ field, fieldState: { error } }) => (
        <>
          <Textarea {...rest} {...field} id={idOrName} error={error?.message} />
        </>
      )}
    />
  );
};
